import { createTestIds } from '@duke-hq/lib/createTestId';

export const testIds = createTestIds('ui-components-AssessmentForm-fields', [
  'textField', // usage: `${textFieldTestIds.input}-${fieldId}`
  'radioGroup', // usage: `${radioFieldTestIds.radioGroup}-${fieldId}`
  'radioOption', // usage: `${radioFieldTestIds.radioOption}-${fieldId}-${optionId}`
  'selectInput', // usage: `${selectFieldTestIds.selectInput}-${fieldId}`
  'selectOption', // usage: `${selectFieldTestIds.selectOption}-${fieldId}-${optionId}`
]);
